import type {HighlightColor} from '../types';

/**
 * Marks the element a whole-supplement mark borders: the supplement's own visual
 * card, whose box and border radius the mark takes over. A wrapper around the whole
 * type renderer can't stand in for it — its box trails the card by the card's own
 * margin, and paint inset into that wrapper hides behind the card's background.
 */
export const SUPPLEMENT_CARD_ATTRIBUTE = 'data-annotation-supplement-card';

export const SUPPLEMENT_CARD_PROPS = {[SUPPLEMENT_CARD_ATTRIBUTE]: ''} as const;

/**
 * On the wrapper wherever a mark is possible, for chrome that must make room for one.
 * Absent outside the feature, which keeps that chrome laid out as it was.
 */
export const SUPPLEMENT_ANNOTATABLE_CLASS = 'annotation-supplement';

/**
 * For a box that clips the card inside it: the edge paints outside that card, so with
 * no slack it shows as a sliver (ImageV2's box has a single pixel).
 */
export const SUPPLEMENT_CARD_CLIP_PROPS = {'data-annotation-supplement-clip': ''} as const;

/** On the wrapper once a mark or a hover names a color: the card paints that edge. */
export const SUPPLEMENT_MARKED_CLASS = 'annotation-supplement-marked';

/** The border color, set on the wrapper and inherited by the card, which paints it. */
export const SUPPLEMENT_BORDER_VARIABLE = '--annotation-supplement-border';

/**
 * The wrapper names the color; the card inherits and paints it. State, not a `hover:`
 * variant, so the classes are plain utilities Tailwind always emits.
 */
export const SUPPLEMENT_BORDER_CLASS_BY_COLOR: Record<HighlightColor, string> = {
  yellow: '[--annotation-supplement-border:var(--color-border-highlight-yellow)]',
  blue: '[--annotation-supplement-border:var(--color-border-highlight-blue)]',
  pink: '[--annotation-supplement-border:var(--color-border-highlight-pink)]'
};

/** The border a hovered, still-unmarked supplement previews. */
export const SUPPLEMENT_HOVER_BORDER_CLASS =
  '[--annotation-supplement-border:var(--color-border-selected)]';
